import { Form, Header } from '@mairistem/composants';
import { EtiquettesInput } from '@mairistem/finances-utils';
import { Liste, ListeQueryContext } from '@mairistem/liste';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import SubventionListeTable from '@/src/components/SubventionListe/SubventionListeTable';
import type { Subvention } from '@/src/interfaces/subvention';

interface SubventionListeProps {
	subventions?: Array<Subvention>;
	count?: number;
	perPage?: number;
	loading?: boolean;
	onLoad?: any;
	onSearch?: any;
	onSort?: any;
	onSelected?: any;
	onExplored?: any;
	onExpanded?: any;
	state?: any;
	mode?: 'expander' | 'explorer';
}

const SubventionListe = (props: SubventionListeProps) => {
	const {
		subventions,
		count,
		perPage,
		loading,
		onLoad,
		onSort,
		onSelected,
		mode,
		...handlers
	} = props;

	const context = React.useContext(ListeQueryContext);
	const [searchClosed, setSearchClosed] = useState(false);
	const [selectedEtiquettes, setSelectedEtiquettes] = useState([]);

	const handleChangeSearchClosed = () => {
		setSearchClosed(!searchClosed);
		context?.filterQuery({ selectCloturedProject: !searchClosed });
	};

	const handleEtiquetteChange = ({ etiquettes }) => {
		setSelectedEtiquettes(etiquettes);
		context.filterQuery({
			...(etiquettes.length > 0 && {
				'etiquettesId[]': etiquettes.map((etiquette) => etiquette.identifiant),
			}),
		});
	};

	const history = useHistory();
	const handleClick = () => {
		history.push('/subventionsPercues');
	};

	return (
		<Liste
			title="Subventions"
			mode={mode}
			searchable
			search={{
				placeholder:
					'Rechercher sur le libellé, le financeur, le projet et le montant attribué',
			}}
			onExpand={handleClick}
			{...handlers}
		>
			<Liste.Header>
				{mode !== 'explorer' ? (
					<Header size="small">
						{count} {count > 1 ? 'subventions' : 'subvention'}
					</Header>
				) : (
					<Form>
						<Form.Group widths="equal">
							<Form.Field
								// @ts-expect-error allowAdditions
								allowAdditions={false}
								control={EtiquettesInput}
								baseUrl="/api/finances/subventionsPercues/etiquettes"
								identifiantEntite={sessionStorage.getItem('identifiantEntite')}
								onChange={handleEtiquetteChange}
								selectedEtiquettes={selectedEtiquettes}
								dropdownProps={{ className: 'etiquettes' }}
							/>
							<Form.Checkbox
								className="filterCheckboxed"
								label="Inclure les aides des projets soldés"
								onChange={handleChangeSearchClosed}
								checked={searchClosed}
							/>
						</Form.Group>
					</Form>
				)}
			</Liste.Header>
			<Liste.Content>
				<SubventionListeTable
					items={subventions}
					loading={loading}
					count={count}
					perPage={perPage}
					onLoad={onLoad}
					onSort={onSort}
					onSelect={onSelected}
					isExplorer={mode === 'explorer'}
				/>
			</Liste.Content>
		</Liste>
	);
};

export default SubventionListe;
